// extracted by mini-css-extract-plugin
export default {"pfp":"ContactCard_pfp__ALdO6"};